import { useItemsBoardStore } from '@/stores/items-board-store'
import { ItemCard } from './ItemCard'
import { AddItemButton } from './AddItemButton'

export function ItemsBoard() {
  const { items } = useItemsBoardStore()

  const lastWeekItems = items.filter((i) => i.status === 'last-week').sort((a, b) => b.order - a.order)
  const currentItems = items.filter((i) => i.status === 'current').sort((a, b) => b.order - a.order)
  const futureItems = items.filter((i) => i.status === 'future').sort((a, b) => a.order - b.order)

  return (
    <div className="bg-white/[0.02] border border-white/[0.06] rounded-lg relative h-full flex flex-col overflow-hidden">
      <div className="flex-1 overflow-auto p-3">
        <div className="grid grid-cols-2 gap-4 pb-12">
          {/* This Week */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-2">This Week</h3>
            {currentItems.length === 0 ? (
              <p className="text-sm text-white/40 text-center py-4">No goals</p>
            ) : (
              <div className="space-y-2">
                {currentItems.map((item) => (
                  <ItemCard key={item.id} item={item} />
                ))}
              </div>
            )}
          </div>
          {/* Last Week + Backlog */}
          <div className="space-y-4">
            {/* Last Week */}
            {lastWeekItems.length > 0 && (
              <div>
                <h3 className="text-xs font-semibold text-white/60 uppercase tracking-wider mb-2">Last Week</h3>
                <div className="space-y-2">
                  {lastWeekItems.map((item) => (
                    <ItemCard key={item.id} item={item} />
                  ))}
                </div>
              </div>
            )}

            {/* Backlog */}
            {futureItems.length > 0 && (
              <div>
                <h3 className="text-xs font-semibold text-white/60 uppercase tracking-wider mb-2">Backlog</h3>
                <div className="space-y-2">
                  {futureItems.map((item) => (
                    <ItemCard key={item.id} item={item} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add Goal button at bottom */}
      <div className="p-3 border-t border-white/[0.06] flex justify-center">
        <AddItemButton />
      </div>
    </div>
  )
}
